import React, { useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import { useEffect } from "react";
import axiosInstance from "../services/axiosInstance";
import { PropagateLoader } from "react-spinners";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      padding: "15px",
      opacity: "1",
      textAlign: "center",
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5) !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
      "&:nth-child(2n)": {
        backgroundColor: "rgba(249, 249, 249, 0.6) !important",
      },
      textAlign: "center",
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF !important",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8) !important",
      borderTop: "1px solid rgba(239, 239, 239, 0.8) !important",
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const KpiTable = ({ loading, setLoading, kpiList, setKpiList }) => {
  useEffect(() => {
    getKpiList();

    const intervalId = setInterval(getKpiList, 30 * 60 * 1000); // 30 minutes in milliseconds
    return () => clearInterval(intervalId);
  }, []);

  const memoizedKpiList = useMemo(() => kpiList, [kpiList]);

  const getKpiList = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/api/userManagement/getKpis");

      const totalActiveOrdersMapped = response.TotalActiveOrders.map(
        (order) => ({
          DepartmentId: 0, // Set 0 or any placeholder if ID is not needed
          DepartmentName: "Gesamt",
          OrdersInDepartment: order["Total Active Orders"],
          Teeths: order["Total Teeths"],
        })
      );

      const mergedData = {
        DepartmentKPI: [...totalActiveOrdersMapped, ...response.DepartmentKPI],
      };

      setKpiList(mergedData?.DepartmentKPI);
    } catch (error) {
      console.error("Error fetching kpi data:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "",
      selector: (row) => row?.DepartmentName,
      sortable: true,
      sortFunction: (rowA, rowB) => {
        // Skip sorting for the first row (index 0)
        if (kpiList.indexOf(rowA) === 0 || kpiList.indexOf(rowB) === 0)
          return 0;
        return rowA.DepartmentName.localeCompare(rowB.DepartmentName);
      },
    },
    {
      name: "Aufträge",
      selector: (row) => row?.OrdersInDepartment,
      sortable: true,
      sortFunction: (rowA, rowB) => {
        if (kpiList.indexOf(rowA) === 0 || kpiList.indexOf(rowB) === 0)
          return 0;
        return rowA.OrdersInDepartment - rowB.OrdersInDepartment;
      },
    },
    {
      name: "Zähne",
      selector: (row) => row?.Teeths,
      sortable: true,
      sortFunction: (rowA, rowB) => {
        if (kpiList.indexOf(rowA) === 0 || kpiList.indexOf(rowB) === 0)
          return 0;
        return rowA.Teeths - rowB.Teeths;
      },
    },
  ];

  return (
    <div>
      {loading ? (
        <div className="flex justify-center items-center min-h-60">
          <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
        </div>
      ) : (
        <DataTable
          noDataComponent={
            <div className="py-4 text-gray-500">
              Es sind keine Datensätze zum Anzeigen vorhanden
            </div>
          }
          className=" mt-6 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular"
          scrollable
          scrollHeight="625px"
          columns={columns}
          fixedHeader
          data={memoizedKpiList || []}
          pagination={false}
          customStyles={customStyles}
          sortIcon={<SortIcon />}
          highlightOnHover
        />
      )}
    </div>
  );
};

export default KpiTable;
